// SICALY: dot navigation for the stacked product gallery on desktop (snippets/sicaly-gallery-dots.liquid).
// Marks the image under the viewport centre with aria-current and scrolls to an image when its dot is pressed.

class SicalyGalleryDots extends HTMLElement {
  connectedCallback() {
    const gallery = this.closest('media-gallery');
    if (!gallery) return;

    this.items = [...gallery.querySelectorAll('.media-gallery__grid > .product-media-container')];
    this.buttons = [...this.querySelectorAll('.sicaly-gallery-dots__button')];
    if (this.items.length < 2) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.#goTo(index), { signal });
    });

    // From 990px the theme scrolls inside .page-wrapper instead of the window (assets/base.css);
    // listen to both, since which one scrolls depends on the viewport width
    document.querySelector('.page-wrapper')?.addEventListener('scroll', this.#onScroll, { passive: true, signal });
    window.addEventListener('scroll', this.#onScroll, { passive: true, signal });
    window.addEventListener('resize', this.#onScroll, { passive: true, signal });
    this.#update();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  #onScroll = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.#update();
    });
  };

  #update() {
    const centre = window.innerHeight / 2;
    let active = 0;

    this.items.forEach((item, index) => {
      if (item.getBoundingClientRect().top <= centre) active = index;
    });

    this.#setActive(active);
  }

  #setActive(active) {
    this.buttons.forEach((button, index) => {
      if (index === active) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  #goTo(index) {
    const item = this.items[index];
    if (!item) return;

    // The header is always sticky: land the image just below it
    const header = document.querySelector('#header-component');
    const headerOffset = header ? header.offsetHeight : 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'instant' : 'smooth';
    const distance = item.getBoundingClientRect().top - headerOffset;
    const wrapper = document.querySelector('.page-wrapper');

    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight && getComputedStyle(wrapper).overflowY !== 'visible') {
      wrapper.scrollBy({ top: distance, behavior });
    } else {
      window.scrollBy({ top: distance, behavior });
    }
    this.#setActive(index);
  }
}

if (!customElements.get('sicaly-gallery-dots')) {
  customElements.define('sicaly-gallery-dots', SicalyGalleryDots);
}
